import React from 'react';
import './AdminHeader.css';

export function AdminHeader() {
  return (
    <div className="admin-header">
      {/* Admin Title */}
      <div className="admin-title-section">
        <div className="admin-title-container">
          <i className="fa-solid fa-cog admin-title-icon"></i>
          <h1 className="admin-main-title">Admin Panel</h1>
        </div>
        <p className="admin-subtitle">Administrative tools and system management</p>
      </div>
    </div>
  );
}